import { CUSTOMER_FORM } from '../form-customer-types';
import useAuth from '../../../../hooks/auth-hooks';
import { showToast } from '../../../toasts';
import { checkForSelectValue } from '../../form-helpers';
import { getParameters } from '../../../../helpers/helpers';

import { awsUpdateCustomer } from '../../../../routes/update-customer-individual';

/**
 * Updates an existing customer using an AWS api route.
 * 
 * @returns void
 */
const UpdateCustomer = () => {
  if ( !CUSTOMER_FORM.customerUpdateForm ) return;

  const {
    customerUpdateForm,
    customerPartner,
    customerSubmit,
    customerName,
    customerAccountNumber,
    customerGallonLimit,
    customerStatus,
    customerFileType,
  } = CUSTOMER_FORM;

  const validateForm = () => {
    customerUpdateForm.classList.add('was-validated');

    checkForSelectValue(customerPartner, 'Partner', 'partner');

    return customerUpdateForm.checkValidity() &&
           customerPartner.getAttribute('data-value') != null;
  }

  const handleSubmit = async (event: Event) => {
    event.preventDefault();
    event.stopPropagation();

    if ( validateForm() ) {
      customerUpdateForm.classList.remove('was-validated');
      customerUpdateForm.classList.remove('form-control:valid');
      customerSubmit.classList.add('aafp_button-loading');
      const userID = getParameters('userID');

      const { userId } = useAuth()!;

      const awsModelData = {
        wpId: userId,
        updateCustomerNum: +userID,
        updateCustomerName: customerName.value,
        updateCustomerAccNum: customerAccountNumber.value,
        updateCustomerGalLimit: customerGallonLimit.valueAsNumber,
        updateCustomerStatus: Number(customerStatus.value),
        updateCustomerFileType: customerFileType.value,
        updateExportTo: 'FTP',
        updateCustomerPartner: Number(customerPartner.getAttribute('data-value'))
      }

      const { statusCode } = await awsUpdateCustomer(awsModelData);

      if ( statusCode === 200 ) {
        showToast('aafp_toast', `${customerName.value} has been updated`);
        setTimeout(() => {
          location.href = '/customers/';
        }, 1500); 
      }
    }
  };

  customerUpdateForm.addEventListener('submit', handleSubmit);
}

export default UpdateCustomer;